const CHAVE_TOKEN_AUTENTICACAO_CLIENTE = 'kgv_auth_token';
const CHAVES_USUARIO_LEGADO = ['currentUser', 'kgv_user'] as const;

// {|INICIO| 23/07/2026 às 09:48 - AUTH: RECUPERAR JWT DE SESSOES LEGADAS PARA PRIORIZAR BEARER}
/**
 * Function-level comment: Extrai o token Bearer armazenado dentro dos objetos legados de sessão do usuário.
 */
function extrairTokenSessaoLegada(valorSerializadoUsuario: string | null): string | null {
  if (!valorSerializadoUsuario) {
    return null;
  }

  try {
    const usuarioParseado = JSON.parse(valorSerializadoUsuario) as { token_autenticacao?: unknown };
    const tokenAutenticacao = typeof usuarioParseado?.token_autenticacao === 'string'
      ? usuarioParseado.token_autenticacao.trim()
      : '';

    return tokenAutenticacao !== '' ? tokenAutenticacao : null;
  } catch {
    return null;
  }
}
// {|FIM| 23/07/2026 às 09:48 - AUTH: RECUPERAR JWT DE SESSOES LEGADAS PARA PRIORIZAR BEARER}

/**
 * Function-level comment: Retorna o token Bearer do cliente autenticado armazenado no navegador.
 */
export function obterTokenAutenticacaoCliente(): string | null {
  if (typeof window === 'undefined') {
    return null;
  }

  const tokenAutenticacao = window.localStorage.getItem(CHAVE_TOKEN_AUTENTICACAO_CLIENTE);
  if (tokenAutenticacao && tokenAutenticacao.trim() !== '') {
    return tokenAutenticacao;
  }

  // {|INICIO| 23/07/2026 às 09:48 - AUTH: RECUPERAR JWT DE SESSOES LEGADAS PARA PRIORIZAR BEARER}
  for (const chaveUsuarioLegado of CHAVES_USUARIO_LEGADO) {
    const tokenSessaoLegada = extrairTokenSessaoLegada(window.localStorage.getItem(chaveUsuarioLegado));
    if (!tokenSessaoLegada) {
      continue;
    }

    window.localStorage.setItem(CHAVE_TOKEN_AUTENTICACAO_CLIENTE, tokenSessaoLegada);
    return tokenSessaoLegada;
  }
  // {|FIM| 23/07/2026 às 09:48 - AUTH: RECUPERAR JWT DE SESSOES LEGADAS PARA PRIORIZAR BEARER}

  return null;
}

/**
 * Function-level comment: Persiste ou remove o token Bearer do cliente conforme o valor informado.
 */
export function salvarTokenAutenticacaoCliente(tokenAutenticacao: string | null): void {
  if (typeof window === 'undefined') {
    return;
  }

  if (tokenAutenticacao && tokenAutenticacao.trim() !== '') {
    window.localStorage.setItem(CHAVE_TOKEN_AUTENTICACAO_CLIENTE, tokenAutenticacao);
    return;
  }

  window.localStorage.removeItem(CHAVE_TOKEN_AUTENTICACAO_CLIENTE);
}

/**
 * Function-level comment: Monta o valor do header Authorization priorizando Bearer do cliente e preservando fallback legado em Basic.
 */
export function montarValorAutorizacao(authSeed: string): string {
  const tokenAutenticacao = obterTokenAutenticacaoCliente();
  if (tokenAutenticacao) {
    return `Bearer ${tokenAutenticacao}`;
  }

  return `Basic ${authSeed}`;
}

/**
 * Verifica se o token de autenticação está expirado
 * @returns true se o token estiver expirado ou não existir, false caso contrário
 */
export function isTokenExpired(): boolean {
  if (typeof window === 'undefined') {
    return true;
  }
  
  const token = obterTokenAutenticacaoCliente();
  if (!token) {
    return true;
  }
  
  try {
    // Decodifica o payload do JWT (a parte do meio, entre os dois pontos)
    const base64Payload = token.split('.')[1];
    const payload = JSON.parse(atob(base64Payload));
    
    if (payload.expires) {
      // payload.expires é um timestamp Unix (segundos), comparar com agora
      const now = Math.floor(Date.now() / 1000);
      return payload.expires < now;
    }
    return false;
  } catch (e) {
    console.error('Erro ao decodificar token:', e);
    return true;
  }
}

/**
 * Function-level comment: Limpa todos os dados de autenticação do usuário e dispara evento de logout.
 */
export function limparAutenticacao(isForced: boolean = false): void {
  if (typeof window === 'undefined') {
    return;
  }

  // Limpa token de autenticação
  window.localStorage.removeItem(CHAVE_TOKEN_AUTENTICACAO_CLIENTE);
  // Limpa dados do usuário logado
  window.localStorage.removeItem('currentUser');
  window.localStorage.removeItem('kgv_user');
  
  // Dispara evento para notificar a app sobre o logout
  const event = new CustomEvent('userLogout', {
    detail: { isForced }
  });
  window.dispatchEvent(event);
}
